<template>
    <div class="alarm_container no_sub_container">
        <!-- alarm start -->
        <div class="set_alarm_container"  v-if="okLight">
            <SelectAlarm
            :alarmStatus="alarmStatus"
            :alarmList="alarmList"
            :routeName="routeName"
            @getChangedStatus="refreshAlarmStatus"
            />
        </div>
        <!-- alarm end -->

        <!-- search start -->
        <div class="alarm_history_container" v-if="okLight">
            <div class="Tb_search_wrap alarm support">
                <form @submit.prevent>
                    <div class="search_wrp">
                        <input
                        type="text"
                        id="search"
                        name="search"
                        class="search_input"
                        :placeholder="$t('alarm.score.searchCoin')"
                        v-model="searchQuery"
                        />
                        <button type="button" class="search_clear" @click="clearSearch"></button>
                    </div>
                </form>
            </div>
        </div>
        <!-- search end -->

        <!-- coin list start -->
        <div class="history_list_warp light-signal">
            <!-- 코인 리스트 api 불러오는 동안 로딩바  start-->
            <div class="subPage_container" v-if="!loadApi || !loadingStatus">
                <div class="loading_spinner">
                    <div class="loading_circle"></div>
                </div>
            </div>
            <!-- 코인 리스트 api 불러오는 동안 로딩바 end -->

            <!-- 권한 없을 경우 안내 멘트 start -->
            <div v-else-if="!okLight" class="ps_nodata next" style="text-align: center">
                <h4 v-if="!promotionPeriod" v-dompurify-html="$t('light.modal')"></h4>
                <h4 v-else v-dompurify-html="$t('alarm.guideMent.access2')"></h4>
            </div>
            <!-- 권한 없을 경우 안내 멘트 end -->

            <!-- 코인 리스트 목록 없을 경우 start -->
            <!-- <div v-else-if="!permission"  class="ps_nodata next">
                {{ $t("popup['temError1']") }}<br/>{{ $t("popup['temError2']") }}
            </div> -->
            <!-- 코인 리스트 목록 없을 경우 end -->


            <!-- 코인 리스트 start -->
            <div class="Tb_data_rapid next" v-else>
                <ul>
                    <li class="light-top">
                        <h3>{{ $t('light.chart') }}</h3>
                        <p>
                            {{ dateConvert }}
                        </p>
                    </li>
                    <li class="light-list" @click="changePage(0)">
                        <div class="light-list-left">
                            <img :src="GreenIcon" alt="icon" class="green"/>
                            <p>{{ $t('light.bullish') }}({{ displayLightCount.bullish }})</p>
                        </div>
                        <img :src="ArrowIcon" alt="arrow icon"/>

                    </li>
                    <li class="light-list" @click="changePage(1)">
                        <div class="light-list-left">
                            <img :src="YellowIcon" alt="icon" class="yellow"/>
                            <p>{{ $t('light.standby') }}({{ displayLightCount.standby }})</p>
                        </div>
                        <img :src="ArrowIcon" alt="arrow icon"/>
                    </li>
                    <li class="light-list" @click="changePage(2)">
                        <div class="light-list-left">
                            <img :src="RedIcon" alt="icon" class="red"/>
                            <p>{{ $t('light.bearish') }}({{ displayLightCount.bearish }})</p>
                        </div>
                        <img :src="ArrowIcon" alt="arrow icon"/>
                    </li>
                    <!-- <li v-for="(history, i) in formattedHistory" :key="i">
                        <div>
                        </div>
                    </li> -->
                </ul>
              
            </div>
            <!-- 코인 리스트 end -->

        </div>
        <!-- coin list end -->
        <AlarmModal v-if="openModal" @close="goAlarmHome" :type="openModal"/>
    </div>
</template> 

<script setup>
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import { ref, onMounted, computed, watch } from "vue";

import { chkPermission } from "@/utils/permission.js";

import AlarmModal from '@/components/alarm/common/AlarmModal.vue'
import SelectAlarm from "@/components/alarm/common/SelectAlarm.vue";
import GreenIcon from "@/assets/images/alarm/light/green.png";
import YellowIcon from "@/assets/images/alarm/light/yellow.png";
import RedIcon from "@/assets/images/alarm/light/red.png";
import ArrowIcon from "@/assets/images/icon/arrow/arrow_right_white.svg";

const store = useStore();
const router = useRouter();
const openModal = ref('');

const { t } = useI18n();

// 화면 로딩 상태
// store의 loadApi는 API 완료 여부
// loadingStatus는 기존처럼 1초 로딩 연출용
const loadingStatus = ref(false);

// 사용자 패키지 정보
const userPackage = ref(0);

// 유저 번호
const userId = ref();

// 검색어
const searchQuery = ref("");

// store state 연결
const routeName = computed(() => store.state.lightAlarm.routeName);
const alarmStatus = computed(() => store.state.lightAlarm.alarmStatus);
const alarmList = computed(() => store.state.lightAlarm.alarmList);
const lightCount = computed(() => store.state.lightAlarm.lightCount);
const dateConvert = computed(() => store.state.lightAlarm.dateConvert);
const loadApi = computed(() => store.state.lightAlarm.loadApi);

// 검색어 소문자 변환
const searchKeyword = computed(() => {
  return searchQuery.value.trim().toLowerCase();
});

// 검색어가 있는지 여부
const hasSearchKeyword = computed(() => {
  return searchKeyword.value.length > 0;
});

// 검색어 기준으로 bullish/standby/bearish 각각 검색된 개수
const searchedLightCount = computed(() => {
  return store.getters["lightAlarm/getSearchCount"](searchQuery.value);
});

// 화면에 표시할 카운트
// 검색어 없으면 API 전체 개수
// 검색어 있으면 "검색됨 n"
const displayLightCount = computed(() => {
  if (!hasSearchKeyword.value) {
    return {
      bullish: lightCount.value.bullish || 0,
      standby: lightCount.value.standby || 0,
      bearish: lightCount.value.bearish || 0,
    };
  }

  return {
    bullish: `검색됨 ${searchedLightCount.value.bullish}`,
    standby: `검색됨 ${searchedLightCount.value.standby}`,
    bearish: `검색됨 ${searchedLightCount.value.bearish}`,
  };
});

// 검색어 지우기
function clearSearch(event) {
  event.preventDefault();
  searchQuery.value = "";
}

// 알람 상태 새로고침
function refreshAlarmStatus() {
  return store.dispatch("lightAlarm/getAlarmStatus", routeName.value);
}

// 알람 상태 + 히스토리 가져오기
async function chgRoute() {
  await refreshAlarmStatus();
  await store.dispatch("lightAlarm/setHistoryList");
}

// 상세 페이지로 이동
function changePage(type) {
  const keyword = searchQuery.value.trim();

  router.push({
    path: "light-detail",
    query: {
      type,

      // 검색어가 있을 때만 query에 search 추가
      ...(keyword && { search: keyword }),
    },
  });
}

// 권한 체크 관련 상태
const result = ref(null);
const checkingPermission = ref(true);
const permission = ref(false);
const isLight = ref(false);
const okLight = ref(false);
const isPayment = ref(0);
const promotionPeriod = ref(true);
const alarmPayment = ref(false);
// const chkLight = ref(false);

// 스마트 플랜 권한 체크
async function chkSmartPlan() {
  try {
    result.value = await chkPermission()

    permission.value = result.value.permission;
    okLight.value = result.value.okLight;
    isLight.value = result.value.isLight;
    isPayment.value = result.value.isPayment;
    userPackage.value = result.value.userPackage;
    alarmPayment.value = result.value.alarmPayment;
    promotionPeriod.value = result.value.isLightPromotionPeriod;
    // chkLight.value = promotionPeriod.value ? okLight.value && alarmPayment.value : okLight.value; 

    if (Number(userPackage.value) < 1000) {
      openModal.value = 'permission';
    }

    if (!okLight.value) {
      promotionPeriod.value ?
        openModal.value = 'isPayment' : openModal.value = 'light';
    }

  } finally {
    checkingPermission.value = false;
  }
}

// 모달 닫기
function goAlarmHome() {
  openModal.value = '';
  router.push('/alarm/dashboard');
}

// 로그인 상태 감지
const loginSuccessful = computed(() => {
  return store.state.loginStatus.loginSuccessful;
});

// 최초 로딩 시 필요한 작업
async function loadSuccess() {
  userId.value = localStorage.getItem("userNum");

  // 앱 WebView 로딩 완료 전달
  if (window.webkit?.messageHandlers?.loadHandler) {
    window.webkit.messageHandlers.loadHandler.postMessage("Load state changed.");
  }

  if (window.Android?.loadTriggered) {
    window.Android.loadTriggered();
  }

  // 알람음 목록은 메인에서 SelectAlarm에 필요
  await store.dispatch("lightAlarm/setAlarmList", t);

  // 권한 체크
  await chkSmartPlan();
}

// 로그인 성공 시 재호출
watch(loginSuccessful, async (newVal) => {
  if (newVal === true) {
    await loadSuccess();
    await chgRoute();

    setTimeout(() => {
      loadingStatus.value = true;
    }, 1000);
  }
});

// 페이지 진입 시 호출
onMounted(async () => {
  await loadSuccess();
  await chgRoute();

  // console.log("Vue history state:", window.history);
  // console.log("Vue history state:", window.history.state);
  // console.log("history length:", window.history.length);

  setTimeout(() => {
    loadingStatus.value = true;
  }, 1000);
});
</script>

<style scoped>
.arrow {
  cursor: pointer;
  transition: transform 0.3s ease;
}

.rotate-down {
  transform: rotate(-180deg);
}

.Tb_data_rapid ul li:active {
    background: transparent !important;
}

.loading_spinner {
    margin: 0;
}

.ps_nodata.next {
    padding-top: 40px;
}

.next-list-info-wrap {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.light-top {
    display: flex;
    flex-direction: column;
    gap: 4px;
    align-items: flex-start;
    padding: 0px 20px 20px;
}

.light-top h3 {
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    line-height: 112.5%; 
}

.light-top p {
    color: var(--Grayscale-Gray30, #B9C3CF);
    font-size: 11px;
    font-weight: 400;
    line-height: 163.636%; 
}

.light-img-wrap {
    position: relative;
    width: 20px;
    height: 20px
}

.light-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    width: 16px;  
    height: 16px;
    z-index: 2;
}

.light-sub-icon {
    width: 100%;
    height: 100%;
    display: block;
    opacity: 0.5;
}

.light-icon.green {
    border-radius: 50%;
    box-shadow: 0 0 4px 0 rgba(27, 190, 158, 0.50), 0 0 16px 0 rgba(27, 190, 158, 0.80);
}

.light-icon.yellow {
    border-radius: 50%;
    box-shadow: 0 0 4px 0 rgba(250, 200, 0, 0.50), 0 0 16px 0 rgba(250, 200, 0, 0.80);
}

.light-icon.red {
    border-radius: 50%;
    box-shadow: 0 0 4px 0 rgba(242, 86, 89, 0.50), 0 0 16px 0 rgba(242, 86, 89, 0.80);
}

.light-list {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 24px 16px;
    flex-direction: row !important;
}

.light-list-left {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-direction: row;
}

.light-list-left p {
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    line-height: 112.5%;
}

.light-list-left img {
    width: 24px;
    height: 24px;
}


</style>
